module.exports = __WEBPACK_EXTERNAL_MODULE_html2canvas__;